// extracted by mini-css-extract-plugin
module.exports = {"Sidedrawer":"Sidedrawer_Sidedrawer__1MEha","Logo":"Sidedrawer_Logo__2dP45","Open":"Sidedrawer_Open__1XS7f","Close":"Sidedrawer_Close__3bqV-"};